module.exports = __webpack_public_path__ + "img/american-express.abd46e67.svg";